// extracted by mini-css-extract-plugin
export var Bottom = "index-module--Bottom--4641e";
export var ExternalLinkButton = "index-module--ExternalLinkButton--465dd";
export var MarginTop = "index-module--MarginTop--fd518";
export var RTL = "index-module--RTL--d50ee";
export var Slim = "index-module--Slim--bb2d1";
export var fadeAndGrowIn = "index-module--fadeAndGrowIn--3ba08";